"use client";
import { usePathname } from "@/i18n/navigation";
import { getFooterMenuData } from "@/utils/footerMenuData";
import { getRouteDetails } from "@/utils/routeHelper";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import FooterMenuColumn from "./FooterMenuColumn";

export default function FooterMenu() {
  const pathname = usePathname();
  const t = useTranslations();
  const routeDetails = getRouteDetails(pathname);
  const { isFlightTicket, isBusTicket, isFerryTicket, isHotel, isCarRental } =
    routeDetails;
  const category = isFlightTicket
    ? "flight"
    : isBusTicket
      ? "bus-ticket"
      : isFerryTicket
        ? "ferry"
        : isHotel
          ? "hotel"
          : isCarRental
            ? "car-rental"
            : "common";
  const footerData = getFooterMenuData(category, t);
  const translatedFooterData = footerData.map((section) => ({
    ...section,
    title: t(section.titleKey),
    items: section.items.map((item) => ({
      ...item,
      text: t(item.textKey),
    })),
  }));

  return (
    <div className="flex flex-col flex-wrap justify-between md:gap-8">
      <div
        className={clsx(
          "grid md:gap-12",
          isFlightTicket || isBusTicket || isFerryTicket || isHotel
            ? "grid-cols-1 lg:grid-cols-3"
            : "grid-cols-1 lg:grid-cols-4",
        )}
      >
        {translatedFooterData
          .slice(
            0,
            isFlightTicket || isBusTicket || isFerryTicket || isHotel ? 3 : 4,
          )
          .map((section) => (
            <FooterMenuColumn
              key={section.key}
              title={section.title}
              items={section.items}
            />
          ))}
      </div>
      <div
        className={clsx(
          "grid md:gap-12",
          isFlightTicket || isBusTicket || isFerryTicket || isHotel
            ? "grid-cols-1 lg:grid-cols-3"
            : "grid-cols-1 lg:grid-cols-4",
        )}
      >
        {translatedFooterData
          .slice(
            isFlightTicket || isBusTicket || isFerryTicket || isHotel ? 3 : 4,
          )
          .map((section) => (
            <FooterMenuColumn
              key={section.key}
              title={section.title}
              items={section.items}
            />
          ))}
      </div>
    </div>
  );
}
